module.exports = __webpack_public_path__ + "img/p3_9.ab43abc9.webp";